import { styled } from '@mui/material/styles';
import { default as BaseLanguageSelector } from './../LanguageSelector';

export const LanguageSelector = styled(BaseLanguageSelector)(({ theme }) => ({
  borderRadius: `${theme.borderRadius.base} 0 0 0`
}));
